module.exports = __webpack_public_path__ + "static/card-education-scholarships-4-0886e5c4dc362a2f4593707084577b58.jpg";